(() => {
  const products = document.querySelectorAll("[data-onura-product]");

  if (!products.length) return;

  const addBusinessDays = (date, days) => {
    const result = new Date(date.getTime());
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();

      if (day !== 0 && day !== 6) {
        added += 1;
      }
    }

    return result;
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat(document.documentElement.lang || "en", {
      day: "numeric",
      month: "short"
    }).format(date);
  };

  const formatMoney = (cents, moneyFormat) => {
    const amount = (Number(cents) / 100).toFixed(2);

    if (!moneyFormat) {
      return `${amount} €`;
    }

    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(amount)).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","));
  };

const getCartSections = () => {
  const cartDrawer = document.querySelector("cart-drawer");

  if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
    return cartDrawer
      .getSectionsToRender()
      .map((section) => section.section || section.id)
      .filter(Boolean);
  }

  return ["cart-drawer", "cart-icon-bubble"];
};

const addItemsToCart = async (items) => {
  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({
      items,
      sections: getCartSections(),
      sections_url: `${window.Shopify?.routes?.root || "/"}cart`
    })
  });

  if (!response.ok) {
    const error = await response.json().catch(() => null);
    throw new Error(error?.description || "Unable to add items to cart.");
  }

  return response.json();
};

  products.forEach((section) => {
    const preorderEnabled = section.getAttribute("data-preorder-enabled") === "true";
    const preorderMessage = section.getAttribute("data-preorder-message") || "";
    const defaultMediaId = section.getAttribute("data-default-media-id");

    const variantsScript = section.querySelector("[data-onura-product-variants]");
    const form = section.querySelector("[data-onura-product-form]");
    const variantInput = section.querySelector("[data-onura-variant-input]");
    const optionInputs = section.querySelectorAll("[data-onura-option-input]");
    const addButton = section.querySelector("[data-onura-add-button]");
    const addButtonText = section.querySelector("[data-onura-add-button-text]");
    const priceNode = section.querySelector("[data-onura-product-price]");
    const comparePriceNode = section.querySelector("[data-onura-product-compare-price]");
    const stockDot = section.querySelector("[data-onura-stock-dot]");
    const stockText = section.querySelector("[data-onura-stock-text]");
    const qtyInput = section.querySelector("[data-onura-qty-input]");
    const qtyMinus = section.querySelector("[data-onura-qty-minus]");
    const qtyPlus = section.querySelector("[data-onura-qty-plus]");

    const mediaSlides = section.querySelectorAll("[data-onura-media-slide]");
    const mediaThumbs = section.querySelectorAll("[data-onura-media-thumb]");
    const mediaThumbsWrapper = section.querySelector("[data-onura-product-thumbs]");

    const accordionToggles = section.querySelectorAll("[data-onura-product-accordion-toggle]");

    const inside = section.querySelector("[data-onura-inside]");
    const insideToggle = inside?.querySelector("[data-onura-inside-toggle]");
    const insideExtraItems = inside?.querySelectorAll("[data-onura-inside-extra]") || [];

    const addon = section.querySelector("[data-onura-addon]");
    const addonVariantsScript = addon?.querySelector("[data-onura-addon-variants]");
    const addonCheckbox = addon?.querySelector("[data-onura-addon-checkbox]");
    const addonOptionInputs = addon?.querySelectorAll("[data-onura-addon-option-input]") || [];
    const addonOfferPricing =
      addon?.querySelector("[data-onura-addon-offer-pricing]")?.getAttribute("data-onura-addon-offer-pricing") === "true";
    const addonPriceNode = addon?.querySelector("[data-onura-addon-price]");
    const addonComparePriceNode = addon?.querySelector("[data-onura-addon-compare-price]");
    const addonStatusNode = addon?.querySelector("[data-onura-addon-status]");
    const addonQuantityMode = section.getAttribute("data-addon-quantity-mode") || "same_as_main";

    if (!variantsScript || !form || !variantInput) return;

    let variants = [];
    let addonVariants = [];
    let selectedMainVariant = null;
    let selectedAddonVariant = null;

   
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }

    if (addonVariantsScript) {
      try {
        addonVariants = JSON.parse(addonVariantsScript.textContent);
      } catch (error) {
        addonVariants = [];
      }
    }

    const moneyFormat = section.getAttribute("data-money-format");
    const deliveryMin = Number(section.getAttribute("data-delivery-min")) || 3;
    const deliveryMax = Number(section.getAttribute("data-delivery-max")) || 6;

    const isAddonSelected = () => {
      return Boolean(addon && addonCheckbox && addonCheckbox.checked);
    };

    const updateDeliveryDates = () => {
      if (!stockText) return;

      const currentMinNode = stockText.querySelector("[data-onura-delivery-min]");
      const currentMaxNode = stockText.querySelector("[data-onura-delivery-max]");

      if (!currentMinNode || !currentMaxNode) return;

      const today = new Date();
      const minDate = addBusinessDays(today, deliveryMin);
      const maxDate = addBusinessDays(today, deliveryMax);

      currentMinNode.textContent = formatDate(minDate);
      currentMaxNode.textContent = formatDate(maxDate);
    };

    const getSelectedOptions = () => {
      const selected = [];

      section.querySelectorAll("[data-onura-option-group]").forEach((group) => {
        const checked = group.querySelector("[data-onura-option-input]:checked");
        selected.push(checked ? checked.value : null);
      });

      return selected;
    };

const findSelectedVariant = () => {
  if (!variants.length) return null;

  const selectedOptions = getSelectedOptions();

  if (!selectedOptions.length) {
    const variantFromInput = getMainVariantFromInput();

    if (variantFromInput) {
      return variantFromInput;
    }

    return variants.find((variant) => variant.available) || variants[0] || null;
  }

  return (
    variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    }) || null
  );
};

const getMainVariantFromInput = () => {
  if (!variantInput || !variantInput.value || !variants || !variants.length) {
    return null;
  }

  return variants.find((variant) => Number(variant.id) === Number(variantInput.value)) || null;
};
    const getSelectedAddonOptions = () => {
      const selected = [];

      addon?.querySelectorAll("[data-onura-addon-option-group]").forEach((group) => {
        const checked = group.querySelector("[data-onura-addon-option-input]:checked");
        selected.push(checked ? checked.value : null);
      });

      return selected;
    };

    

    const findSelectedAddonVariant = () => {
      if (!addon || !addonVariants.length) return null;

      const selectedOptions = getSelectedAddonOptions();

      if (!selectedOptions.length) {
        return addonVariants.find((variant) => variant.available) || addonVariants[0] || null;
      }

      return (
        addonVariants.find((variant) => {
          return variant.options.every((option, index) => option === selectedOptions[index]);
        }) || null
      );
    };

    const revealAllMedia = () => {
      mediaSlides.forEach((slide) => {
        slide.classList.remove("is-hidden-by-variant");
        slide.removeAttribute("hidden");
      });

      mediaThumbs.forEach((thumb) => {
        thumb.classList.remove("is-hidden-by-variant");
        thumb.removeAttribute("hidden");
      });
    };

    const setActiveMedia = (mediaId) => {
      if (!mediaId) return;

      revealAllMedia();

      mediaSlides.forEach((slide) => {
        slide.classList.toggle("is-active", slide.getAttribute("data-media-id") === String(mediaId));
      });

      mediaThumbs.forEach((thumb) => {
        thumb.classList.toggle("is-active", thumb.getAttribute("data-media-id") === String(mediaId));
      });
    };

    const getInitialMediaId = () => {
      if (defaultMediaId) return defaultMediaId;

      const activeSlide = section.querySelector("[data-onura-media-slide].is-active");
      if (activeSlide) return activeSlide.getAttribute("data-media-id");

      const firstSlide = section.querySelector("[data-onura-media-slide]");
      if (firstSlide) return firstSlide.getAttribute("data-media-id");

      return null;
    };

    const getVisibleThumbs = () => {
      return Array.from(mediaThumbs).filter((thumb) => {
        return (
          !thumb.hasAttribute("hidden") &&
          !thumb.classList.contains("is-hidden-by-variant") &&
          thumb.offsetParent !== null
        );
      });
    };

    const getThumbStep = () => {
      const visibleThumbs = getVisibleThumbs();

      if (!visibleThumbs.length) return 96;

      const firstThumb = visibleThumbs[0];
      const styles = mediaThumbsWrapper ? window.getComputedStyle(mediaThumbsWrapper) : null;
      const gap = styles ? parseFloat(styles.rowGap || styles.gap || "10") || 10 : 10;

      return firstThumb.offsetHeight + gap;
    };

    const autoMoveThumbCarousel = (thumb) => {
      if (!mediaThumbsWrapper || !thumb) return;

      const visibleThumbs = getVisibleThumbs();

      if (visibleThumbs.length <= 6) return;

      const wrapperRect = mediaThumbsWrapper.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const step = getThumbStep();

      const isNearBottom = thumbRect.bottom > wrapperRect.bottom - step * 1.25;
      const isNearTop = thumbRect.top < wrapperRect.top + step * 1.25;

      if (isNearBottom) {
        mediaThumbsWrapper.scrollBy({
          top: step * 3,
          behavior: "smooth"
        });

        return;
      }

      if (isNearTop) {
        mediaThumbsWrapper.scrollBy({
          top: -step * 3,
          behavior: "smooth"
        });
      }
    };

    const activateThumb = (thumb) => {
      if (!thumb) return;

      const mediaId = thumb.getAttribute("data-media-id");

      if (!mediaId) return;

      setActiveMedia(mediaId);
      autoMoveThumbCarousel(thumb);
    };

    const getActiveThumbByMediaId = (mediaId) => {
      if (!mediaId) return null;

      return Array.from(mediaThumbs).find((thumb) => {
        return thumb.getAttribute("data-media-id") === String(mediaId);
      });
    };

    const updateAddonState = () => {
      if (!addon) return;

      selectedAddonVariant = findSelectedAddonVariant();

      form.classList.toggle("is-addon-selected", isAddonSelected());

      if (!selectedAddonVariant) {
        if (addonStatusNode) {
          addonStatusNode.textContent = "This add-on is currently unavailable.";
        }

        return;
      }

      if (!addonOfferPricing) {
        if (addonPriceNode) {
          addonPriceNode.textContent = formatMoney(selectedAddonVariant.price, moneyFormat);
        }

        if (addonComparePriceNode) {
          if (selectedAddonVariant.compare_at_price && selectedAddonVariant.compare_at_price > selectedAddonVariant.price) {
            addonComparePriceNode.textContent = formatMoney(selectedAddonVariant.compare_at_price, moneyFormat);
            addonComparePriceNode.classList.remove("is-hidden");
          } else {
            addonComparePriceNode.textContent = "";
            addonComparePriceNode.classList.add("is-hidden");
          }
        }
      }

      if (addonStatusNode) {
        addonStatusNode.textContent = selectedAddonVariant.available
          ? "Available as an add-on."
          : "This add-on variant is currently unavailable.";
      }

      updateAddButtonState();
    };



const updateAddButtonState = () => {
  if (!addButton || !addButtonText) return;

  const mainVariant = selectedMainVariant || getMainVariantFromInput();

  if (!mainVariant) {
    addButton.disabled = true;
    addButtonText.textContent = "Unavailable";
    return;
  }

  if (!mainVariant.available) {
    addButton.disabled = true;
    addButtonText.textContent = "Sold out";
    return;
  }

  if (isAddonSelected() && (!selectedAddonVariant || !selectedAddonVariant.available)) {
    addButton.disabled = true;
    addButtonText.textContent = "Add-on unavailable";
    return;
  }

  addButton.disabled = false;
  addButtonText.textContent = isAddonSelected() ? "Add both to cart" : "Add to cart";
};

    const updateProductState = (options = {}) => {
      const updateMedia = options.updateMedia === true;
      const variant = findSelectedVariant();

      selectedMainVariant = variant;

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = "Unavailable";
        return;
      }

      variantInput.value = variant.id;

      if (priceNode) {
        priceNode.textContent = formatMoney(variant.price, moneyFormat);
      }

      if (comparePriceNode) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceNode.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePriceNode.classList.remove("is-hidden");
        } else {
          comparePriceNode.textContent = "";
          comparePriceNode.classList.add("is-hidden");
        }
      }

      if (stockDot) {
        const shouldShowAvailableDot = preorderEnabled || variant.available;

        stockDot.classList.toggle("is-available", shouldShowAvailableDot);
        stockDot.classList.toggle("is-unavailable", !shouldShowAvailableDot);
      }

      if (stockText) {
        if (preorderEnabled) {
          stockText.textContent = preorderMessage;
        } else if (variant.available) {
          stockText.innerHTML = `In stock: Delivered between <span data-onura-delivery-min></span> and <span data-onura-delivery-max></span>`;
          updateDeliveryDates();
        } else {
          stockText.textContent = "Soon back in stock";
        }
      }

      revealAllMedia();

      if (updateMedia && variant.featured_media && variant.featured_media.id) {
        setActiveMedia(variant.featured_media.id);

        const activeThumb = getActiveThumbByMediaId(variant.featured_media.id);

        if (activeThumb && mediaThumbsWrapper) {
          activeThumb.scrollIntoView({
            block: "nearest",
            inline: "nearest",
            behavior: "smooth"
          });
        }
      }

      updateAddonState();
      updateAddButtonState();
    };

    optionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        updateProductState({ updateMedia: true });
      });
    });

    addonOptionInputs.forEach((input) => {
      input.addEventListener("change", updateAddonState);
    });

    if (addonCheckbox) {
      addonCheckbox.addEventListener("change", updateAddonState);
    }

    if (insideToggle && insideExtraItems.length) {
      const insideToggleLabel = insideToggle.querySelector("[data-onura-inside-toggle-label]");
      const labelMore = insideToggle.getAttribute("data-label-more") || "View more";
      const labelLess = insideToggle.getAttribute("data-label-less") || "View less";

      insideToggle.addEventListener("click", () => {
        const isExpanded = inside.classList.contains("is-expanded");

        if (isExpanded) {
          inside.classList.remove("is-expanded");
          insideToggle.setAttribute("aria-expanded", "false");

          if (insideToggleLabel) {
            insideToggleLabel.textContent = labelMore;
          }

          insideExtraItems.forEach((item) => {
            item.classList.remove("is-visible");
          });

          window.setTimeout(() => {
            insideExtraItems.forEach((item) => {
              if (!inside.classList.contains("is-expanded")) {
                item.setAttribute("hidden", "");
              }
            });
          }, 460);

          return;
        }

        inside.classList.add("is-expanded");
        insideToggle.setAttribute("aria-expanded", "true");

        if (insideToggleLabel) {
          insideToggleLabel.textContent = labelLess;
        }

        insideExtraItems.forEach((item, index) => {
          item.removeAttribute("hidden");

          window.setTimeout(() => {
            item.classList.add("is-visible");
          }, index * 55);
        });
      });
    }

    if (mediaThumbsWrapper) {
      let isDraggingThumbs = false;
      let didDragThumbs = false;
      let suppressNextClick = false;
      let startY = 0;
      let startScrollTop = 0;
      let startThumb = null;

      const isMobileGallery = () => {
        return window.matchMedia("(max-width: 989px)").matches;
      };

      mediaThumbsWrapper.addEventListener("click", (event) => {
        const thumb = event.target.closest("[data-onura-media-thumb]");

        if (!thumb || !mediaThumbsWrapper.contains(thumb)) return;

        event.preventDefault();
        event.stopPropagation();

        if (suppressNextClick) return;

        activateThumb(thumb);
      });

      mediaThumbsWrapper.addEventListener("pointerdown", (event) => {
        if (isMobileGallery()) return;
        if (event.button !== 0) return;

        startThumb = event.target.closest("[data-onura-media-thumb]");
        isDraggingThumbs = true;
        didDragThumbs = false;
        suppressNextClick = false;
        startY = event.clientY;
        startScrollTop = mediaThumbsWrapper.scrollTop;

        mediaThumbsWrapper.classList.add("is-onura-thumb-dragging");

        try {
          mediaThumbsWrapper.setPointerCapture(event.pointerId);
        } catch (error) {
          /* Pointer capture may fail on some browsers. */
        }
      });

      mediaThumbsWrapper.addEventListener("pointermove", (event) => {
        if (!isDraggingThumbs) return;

        const diff = event.clientY - startY;

        if (Math.abs(diff) > 5) {
          didDragThumbs = true;
          mediaThumbsWrapper.scrollTop = startScrollTop - diff;
        }
      });

      mediaThumbsWrapper.addEventListener("pointerup", (event) => {
        if (!isDraggingThumbs) return;

        isDraggingThumbs = false;
        mediaThumbsWrapper.classList.remove("is-onura-thumb-dragging");

        try {
          mediaThumbsWrapper.releasePointerCapture(event.pointerId);
        } catch (error) {
          /* Pointer may already be released. */
        }

        if (!didDragThumbs && startThumb) {
          suppressNextClick = true;
          activateThumb(startThumb);

          window.setTimeout(() => {
            suppressNextClick = false;
          }, 160);
        }

        if (didDragThumbs) {
          suppressNextClick = true;

          window.setTimeout(() => {
            suppressNextClick = false;
          }, 160);
        }

        startThumb = null;

        window.setTimeout(() => {
          didDragThumbs = false;
        }, 90);
      });

      mediaThumbsWrapper.addEventListener("pointercancel", () => {
        isDraggingThumbs = false;
        didDragThumbs = false;
        suppressNextClick = false;
        startThumb = null;
        mediaThumbsWrapper.classList.remove("is-onura-thumb-dragging");
      });
    } else {
      mediaThumbs.forEach((thumb) => {
        thumb.addEventListener("click", (event) => {
          event.preventDefault();
          activateThumb(thumb);
        });
      });
    }

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener("click", () => {
        const currentValue = Math.max(1, Number(qtyInput.value) || 1);
        qtyInput.value = Math.max(1, currentValue - 1);
      });
    }

    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener("click", () => {
        const currentValue = Math.max(1, Number(qtyInput.value) || 1);
        qtyInput.value = currentValue + 1;
      });
    }

    accordionToggles.forEach((toggle) => {
      const panelId = toggle.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;

      if (!panel) return;

      panel.style.maxHeight = "0px";

      toggle.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        if (isOpen) {
          toggle.setAttribute("aria-expanded", "false");

          panel.style.maxHeight = `${panel.scrollHeight}px`;

          window.requestAnimationFrame(() => {
            panel.classList.remove("is-open");
            panel.style.maxHeight = "0px";
          });

          window.setTimeout(() => {
            if (toggle.getAttribute("aria-expanded") === "false") {
              panel.setAttribute("hidden", "");
            }
          }, 560);

          return;
        }

        toggle.setAttribute("aria-expanded", "true");
        panel.removeAttribute("hidden");

        window.requestAnimationFrame(() => {
          panel.classList.add("is-open");
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        });

        window.setTimeout(() => {
          if (toggle.getAttribute("aria-expanded") === "true") {
            panel.style.maxHeight = "none";
          }
        }, 580);
      });
    });

    form.addEventListener("submit", async (event) => {
      if (!isAddonSelected()) {
        window.setTimeout(() => {
          document.dispatchEvent(new CustomEvent("onura:cart:update"));
        }, 600);

        return;
      }

      event.preventDefault();

      if (!selectedMainVariant || !selectedMainVariant.available) return;
      if (!selectedAddonVariant || !selectedAddonVariant.available) return;

      const mainQuantity = Math.max(1, Number(qtyInput?.value) || 1);
      const addonQuantity = addonQuantityMode === "one" ? 1 : mainQuantity;

      try {
        form.classList.add("is-adding");

        if (addButtonText) {
          addButtonText.textContent = "Adding...";
        }

const cartResponse = await addItemsToCart([
  {
    id: Number(selectedMainVariant.id),
    quantity: mainQuantity
  },
  {
    id: Number(selectedAddonVariant.id),
    quantity: addonQuantity,
    properties: {
      "_bundle_addon": "ARARI Box add-on",
      "_bundle_discount_expected": "19.90"
    }
  }
]);

const cartDrawer = document.querySelector("cart-drawer");

if (cartDrawer && typeof cartDrawer.renderContents === "function") {
  cartDrawer.classList.remove("is-empty");
  cartDrawer.renderContents(cartResponse);
} else {
  document.dispatchEvent(new CustomEvent("onura:cart:update"));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
  document.dispatchEvent(new CustomEvent("cart:updated"));
}

        if (addButtonText) {
          addButtonText.textContent = "Added";
        }

        window.setTimeout(() => {
          updateAddButtonState();
        }, 1400);
      } catch (error) {
        if (addButtonText) {
          addButtonText.textContent = "Try again";
        }

        console.error(error);
      } finally {
        form.classList.remove("is-adding");
      }
    });

    revealAllMedia();

    const initialMediaId = getInitialMediaId();

    if (initialMediaId) {
      setActiveMedia(initialMediaId);
    }

updateDeliveryDates();

selectedMainVariant = getMainVariantFromInput() || findSelectedVariant();

if (selectedMainVariant) {
  variantInput.value = selectedMainVariant.id;
}

updateProductState({ updateMedia: false });
updateAddButtonState();
  });
})();